/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do injection volume and gradient scale?`)
};

const es_hplc_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo escalan el volumen de inyección y el gradiente?`)
};

const de_hplc_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie skalieren Injektionsvolumen und Gradient?`)
};

const nl_hplc_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe schalen injectievolume en gradiënt?`)
};

const fr_hplc_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment le volume d'injection et le gradient s'adaptent-ils ?`)
};

const it_hplc_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come scalano volume di iniezione e gradiente?`)
};

const pt_br2_hplc_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como o volume de injeção e o gradiente são dimensionados?`)
};

const pt_hplc_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como escalam o volume de injeção e o gradiente?`)
};

const ja_hplc_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注入量とグラジエントはどのようにスケーリングされますか?`)
};

const zh_hplc_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进样量和梯度时间是如何变化的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_faq_q3", locale)
	if (locale === "en") return en_hplc_faq_q3(inputs)
	if (locale === "es") return es_hplc_faq_q3(inputs)
	if (locale === "de") return de_hplc_faq_q3(inputs)
	if (locale === "nl") return nl_hplc_faq_q3(inputs)
	if (locale === "fr") return fr_hplc_faq_q3(inputs)
	if (locale === "it") return it_hplc_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_faq_q3(inputs)
	if (locale === "pt") return pt_hplc_faq_q3(inputs)
	if (locale === "ja") return ja_hplc_faq_q3(inputs)
	return zh_hplc_faq_q3(inputs)
};